/*
 * Sterntaler – voraussichtliches Lieferdatum auf der PDP
 * Rechnet exakt wie die Bestellbestätigung:
 *  - Start = heute (Europe/Berlin), am Wochenende/Feiertag der nächste Versandtag;
 *    gezählt werden die folgenden Werktage
 *  - Wochenenden und Feiertage (Konfig) werden übersprungen
 *  - Betriebsurlaub: Zählung startet ab dem Wiederaufnahme-Tag
 *  - Personalisierung (Artikel oder bereits im Warenkorb): +1 / +3 Werktage
 *  - Express (nur DE, ohne Personalisierung): bis 11 Uhr 1 Werktag, sonst 2
 * Konfiguration: snippets/sterntaler-delivery-config.liquid
 * Ziele:
 *  [data-st-delivery]        -> Lieferbox unter dem Warenkorb-Button
 *  [data-st-delivery-short]  -> kurze Zeile (z. B. Sticky-Leiste)
 */
(function () {
  if (window.SterntalerDeliveryInit) return;
  window.SterntalerDeliveryInit = true;

  var cfgEl = document.querySelector('[data-st-delivery-config]');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var DAY = 86400000;
  var state = {
    productPerso: !!window.SterntalerPersoActive,
    cartPerso: !!CFG.cartHasPerso
  };

  /* ---------- Datum in Berlin ---------- */
  function berlinNow() {
    // Teile der aktuellen Berliner Uhrzeit, unabhängig von der Zeitzone des Geräts
    var parts = {};
    try {
      new Intl.DateTimeFormat('de-DE', {
        timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false
      }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
      return { y: +parts.year, m: +parts.month, d: +parts.day, h: +parts.hour % 24 };
    } catch (e) {
      var n = new Date();
      return { y: n.getFullYear(), m: n.getMonth() + 1, d: n.getDate(), h: n.getHours() };
    }
  }
  // Reine Kalendertage als UTC-Mitternacht, damit Sommer/Winterzeit nichts verschiebt
  function utcDay(y, m, d) { return Date.UTC(y, m - 1, d); }
  function ymd(ts) {
    var d = new Date(ts);
    return '' + d.getUTCFullYear() + String(d.getUTCMonth() + 1).padStart(2, '0') + String(d.getUTCDate()).padStart(2, '0');
  }
  function isShippingDay(ts) {
    var wd = new Date(ts).getUTCDay(); // 0 = So, 6 = Sa
    return wd !== 0 && wd !== 6 && (CFG.holidays || []).indexOf(ymd(ts)) === -1;
  }

  // Personalisierung nicht besetzt (persoPause: ["JJJJMMTT", "JJJJMMTT"])
  var pauseHit = false;
  function inPersoPause(ts) {
    var p = CFG.persoPause;
    if (!p || !p[0] || !p[1]) return false;
    var d = ymd(ts);
    return d >= String(p[0]) && d <= String(p[1]);
  }
  // Ein Datum: target Werktage ab start; die ersten persoDays davon (Bearbeitung der
  // Personalisierung) dürfen nicht in der Personalisierungs-Pause liegen.
  function businessDay(start, target, persoDays) {
    var cursor = start, counted = 0;
    for (var i = 0; i < 90; i++) {
      cursor += DAY;
      if (!isShippingDay(cursor)) continue;
      if (counted < persoDays && inPersoPause(cursor)) { pauseHit = true; continue; }
      counted++;
      if (counted >= target) return cursor;
    }
    return null;
  }

  function startCursor(now) {
    var cursor = utcDay(now.y, now.m, now.d);
    if (CFG.vacationActive && CFG.vacationUntil) {
      var p = CFG.vacationUntil.split('-');
      var until = utcDay(+p[0], +p[1], +p[2]);
      if (until > cursor) return until - DAY;
    }
    // Kein Versand an Wochenenden/Feiertagen: Bestellung zählt wie eine vom
    // nächsten Versandtag (Sonntag = Montag) – gleiche Logik wie die Bestellbestätigung
    for (var i = 0; i < 14 && !isShippingDay(cursor); i++) cursor += DAY;
    return cursor;
  }

  // Liefert die Tage für min/max Werktage ab dem Start (wie die for-Schleife der Bestellbestätigung)
  function addBusinessDays(start, min, max) {
    var cursor = start, counted = 0, minTs = null, maxTs = null;
    for (var i = 0; i < 60; i++) {
      cursor += DAY;
      if (!isShippingDay(cursor)) continue;
      counted++;
      if (counted === min) minTs = cursor;
      if (counted === max) { maxTs = cursor; break; }
    }
    return { min: minTs, max: maxTs };
  }

  var WD = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];
  function fmt(ts) {
    var d = new Date(ts);
    return WD[d.getUTCDay()] + ' ' + String(d.getUTCDate()).padStart(2, '0') + '.' + String(d.getUTCMonth() + 1).padStart(2, '0') + '.';
  }
  function fmtRange(r) {
    if (!r.min || !r.max) return '';
    return r.min === r.max ? fmt(r.max) : fmt(r.min) + ' – ' + fmt(r.max);
  }

  /* ---------- Berechnung ---------- */
  function compute() {
    var c = (CFG.countries || {})[CFG.country];
    if (!c) return null;
    var now = berlinNow();
    var start = startCursor(now);
    var perso = state.productPerso || state.cartPerso;
    var buf = CFG.persoBuffer || [1, 3];

    pauseHit = false;
    var range = perso
      ? { min: businessDay(start, c.min + buf[0], buf[0]), max: businessDay(start, c.max + buf[1], buf[1]) }
      : addBusinessDays(start, c.min, c.max);

    var out = { range: fmtRange(range), perso: perso, country: CFG.country, note: c.note || '' };

    if (c.express && !perso) {
      // Am Wochenende / Feiertag wird nicht versendet: die Bestellung geht am nächsten
      // Versandtag raus (vor dem Cut-off) – Express zählt also ab diesem Tag.
      var offDay = start !== utcDay(now.y, now.m, now.d);
      var beforeCutoff = offDay || now.h < c.expressCutoff;
      var days = beforeCutoff ? c.expressFast : c.expressSlow;
      var ex = addBusinessDays(start, days, days);
      out.express = 'Express: ' + (beforeCutoff && !offDay ? 'bis ' + c.expressCutoff + ' Uhr bestellt, ' : '') + fmt(ex.max) + ' bei dir';
      out.expressPrice = c.expressPrice || '';
    }
    if (perso && c.expressPerso) {
      out.expressPerso = 'Mit Express-Bearbeitung im Checkout: ' + fmtRange({ min: businessDay(start, c.expressPerso[0], 1), max: businessDay(start, c.expressPerso[1], 1) });
    }
    if (perso && pauseHit && CFG.persoPause) {
      var f = function (v) { v = String(v); return v.slice(6, 8) + '.' + v.slice(4, 6) + '.' + v.slice(0, 4); };
      out.pauseNote = 'Vom ' + f(CFG.persoPause[0]) + ' bis ' + f(CFG.persoPause[1]) + ' ist unsere Personalisierung nicht besetzt – das ist bereits berücksichtigt.';
    }
    return out;
  }

  /* ---------- Express-Info (Aufpreis) ---------- */
  var infoId = 0;
  function expressInfo(box, price) {
    var wrap = document.createElement('span');
    wrap.className = 'st-delivery__info';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'st-delivery__info-btn';
    btn.setAttribute('aria-label', 'Info zum Expressversand');
    btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="11"/><circle cx="12" cy="7.5" r="0.6" fill="currentColor"/></svg>';
    var tip = document.createElement('span');
    tip.className = 'st-delivery__info-tip';
    tip.id = 'StExpressInfo-' + (++infoId);
    tip.setAttribute('role', 'status');
    tip.textContent = 'Expressversand: ' + price + ' Aufpreis, im Checkout wählbar.';
    var open = box.dataset.expressInfoOpen === '1';
    tip.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.setAttribute('aria-controls', tip.id);
    btn.addEventListener('click', function () {
      var isOpen = tip.hidden;
      tip.hidden = !isOpen;
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      box.dataset.expressInfoOpen = isOpen ? '1' : '';
    });
    wrap.appendChild(btn);
    wrap.appendChild(tip);
    return wrap;
  }

  /* ---------- Ausgabe ---------- */
  function render() {
    var r = compute();
    document.querySelectorAll('[data-st-delivery]').forEach(function (box) {
      if (!r || !r.range) { box.hidden = true; return; }
      box.hidden = false;
      var range = box.querySelector('[data-dl-range]');
      var note = box.querySelector('[data-dl-note]');
      if (range) range.textContent = r.range;
      if (note) {
        var lines = [];
        if (r.perso) {
          lines.push(state.productPerso
            ? 'Inkl. 1–3 Werktage für die Personalisierung.'
            : 'Inkl. 1–3 Werktage, da dein Warenkorb einen personalisierten Artikel enthält.');
          if (r.pauseNote) lines.push(r.pauseNote);
          if (r.expressPerso) lines.push(r.expressPerso);
        } else if (r.express) {
          lines.push(r.express);
        }
        if (r.note) lines.push(r.note);
        note.textContent = '';
        lines.forEach(function (l, i) {
          if (i) note.appendChild(document.createElement('br'));
          note.appendChild(document.createTextNode(l));
          // Express-Aufpreis nicht im Satz, sondern als Info-Symbol am Ende der Zeile
          if (l === r.express && r.expressPrice) note.appendChild(expressInfo(box, r.expressPrice));
        });
        note.hidden = lines.length === 0;
      }
    });
    document.querySelectorAll('[data-st-delivery-short]').forEach(function (el) {
      if (r && r.range) el.textContent = 'Lieferung ' + r.range;
    });
  }

  /* ---------- Personalisierung & Warenkorb beobachten ---------- */
  // Personalisierung über das versteckte Feld properties[Personalisierung] (Popup-Variante)
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.name !== 'properties[Personalisierung]') return;
    state.productPerso = !!(t.value && t.value.trim());
    render();
  });
  document.addEventListener('sterntaler:personalization-change', function (e) {
    state.productPerso = !!(e.detail && e.detail.active);
    render();
  });

  function refreshCart() {
    fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        state.cartPerso = (cart.items || []).some(function (i) { return i.sku === 'Bestickung_000000'; });
        render();
      })
      .catch(function () {});
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    try { subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refreshCart, 300); }); } catch (e) {}
  }

  // Um 11 Uhr bzw. Mitternacht ändert sich die Aussage – minütlich prüfen reicht
  setInterval(render, 60000);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render);
  else render();

  window.SterntalerDelivery = { compute: compute, render: render, _state: state };
})();